"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerRequestTransferHandler = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@nfid/core");
function registerRequestTransferHandler(handler) {
    const p = new Promise((resolve) => {
        window.addEventListener('message', function nfidHandler(event) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (!(0, core_1.validateSameOrigin)(event, window.opener))
                    return;
                // We accept RequestTransfer requests from the client
                if (event.data.kind === 'RequestTransfer') {
                    resolve(event.data.params);
                    console.debug(`registerRequestTransferHandler: request received, triggering handler.`, event);
                    (0, core_1.postMessageToClient)({
                        kind: 'RequestTransferResponse',
                        result: yield handler(),
                    });
                    window.removeEventListener('message', nfidHandler);
                    window.close();
                }
            });
        });
    });
    (0, core_1.postMessageToClient)({ kind: 'Ready' });
    return p;
}
exports.registerRequestTransferHandler = registerRequestTransferHandler;
